/**
 * objednávkový fromulář
 */

if(ID["frm-orderForm"]) {

    document.querySelectorAll('select[name*=Country]').forEach(el => {

        el.addEventListener('change', e => {

            //FNP.order.setShippingPayment(FNP.order.getCountryCode())
            //ID.shipping.value = '';
            //ID.payment.value = '';
       
            ID["frm-orderForm"].shippingRadio.forEach(el => {
                el.checked = false;
            });

            ID["frm-orderForm"].paymentRadio.forEach(el => {
                el.checked = false;
            });

            if (!_.isEmpty(shipping) && !_.isEmpty(payment)) {
                FNP.order.shippingPrice(document.location.pathname + '?do=shippingPrice');
            }

        })
    });

    document.querySelectorAll('[type=radio][data-type]').forEach(element => {

        element.addEventListener('click', e => {

            let input = e.target;
            if (input.dataset.type === 'shipping') {
                ID.shipping.dataset.parent = input.dataset.parent;
            }
        });

        element.addEventListener('change', e => {

            let input = e.target;
            ID[input.dataset.type].value = input.value;

            if (input.dataset.type === 'shipping') {
                let sb = ID["selected-branch-" + input.dataset.parent];
                if(sb) sb.value = null;
                ID.payment.value = null;
                FN.checkRadioValue(ID["frm-orderForm"], "shippingRadio", ID.shipping.value);
                FN.checkRadioValue(ID["frm-orderForm"], "paymentRadio", ID.payment.value);

                FN.uncheckInput('.payment-item input');
                document.querySelectorAll('[type=radio][data-type]').forEach(item =>
                    item==input ? item.parentNode.classList.add("active") : item.parentNode.classList.remove("active")
                );
            }

            if (input.dataset.link) {
                FNP.order.shippingPrice(input.dataset.link);
            }
        })
    })

    FNP.order.getCountryCode = _ => document.querySelector("[name=deliveryCountry]")?.value || document.querySelector("[name=billingCountry]")?.value;

    naja.addEventListener('success', _=> (_=FNP.order.getCountryCode()) && FNP.order.setShippingPayment(_));


    FNP.order.setShippingPayment = countryCode => {
        document.querySelectorAll('[type=radio][data-type]').forEach(item => item.parentNode.classList.add('d-none'));
        countryCode && document.querySelectorAll(`div[data-shipping-country=${countryCode}]`).forEach(item => item.classList.remove('d-none'));
        document.querySelectorAll('[data-alert]').forEach(element => countryCode ? element.classList.add('d-none') : element.classList.remove('d-none'));
        if (ID['shipping-branch'].value === '0') {
            FN.uncheckInputs('[data-type]');
        }

        if (ID['shipping-branch'] && ID['shipping-branch'].value !== '' && ID['shipping-branch'].value != null && ID['shipping-branch'].value != 0) {
            ID["frm-orderForm"].shippingRadio.value = ID.shipping.value;
        }    

        ID["frm-orderForm"].paymentRadio.value = ID.payment.value;
        document.querySelectorAll('[type=radio][data-type]').forEach(item =>
            item.checked ? item.parentNode.classList.add("active") : item.parentNode.classList.remove("active")
        );

    }


    FNP.order.shippingPrice = link => {

        let
            shipping = ID.shipping.value,
            payment = ID.payment.value,
            branchId = ID["shipping-branch"].value;

        if(branchId && !payment) {
            ID["shipping-branch"].value = branchId = '';
            document.querySelectorAll('.shipping.radiogaga .title').forEach(element => {
                element.parentNode.classList.add("d-none");
            });
        }

        naja.makeRequest('POST', link, {
            shipping: shipping,
            payment: payment,
            branchId: branchId,
            parentId: ID.shipping.dataset.parent
        }, {
            history: false
        }).then(r => {
            if (ID.shipping.dataset.parent) {
                let selected = ID['selected-branch-' + ID.shipping.dataset.parent];

                if (selected) {

                    if (!_.isUndefined(r.branchData)) {
                        selected.classList.remove('d-none');
                        selected.querySelector(".title").innerHTML = r.branchData.address;

                        let input = ID["selected-shipping-" + ID.shipping.dataset.parent];
                        input.checked = true;

                    }

                    if (!_.isEmpty(r.branchData)) {
                        [...document.querySelectorAll('div.info')].forEach(element => {
                            element.classList.add('d-none');

                        });

                    }

                }



                /*if (r.branchData.priceVat !== 0) {
                    document.getElementById('shipping-price-' + r.branchData.parentId).removeAttribute('data-free');
                    document.getElementById('shipping-price-' + r.branchData.parentId).innerHTML = r.branchData.price;
                }*/
            }

            if (r.payments) {
                [...document.getElementsByName('paymentRadio')].forEach(element => {
                    element.removeAttribute('disabled');
                    if (!r.payments.includes(element.value)) element.setAttribute('disabled', true);
                });

            }
        })
    }

    window.addEventListener('load', _ => {
        if (ID.shipping.value && ID.payment.value) {
            FNP.order.shippingPrice(document.location.pathname + '?do=shippingPrice')
        } /*else {
            const branchId = ID["shipping-branch"].value;
            if (branchId) {
                FNC.shippingModal.selectBranch(branchId, ID.shipping.dataset.parent);
            }
        }*/

        // nastavení doprav a pleteb podle zeme
        const
            billingCountry = document.getElementById('frm-orderForm-billingCountry').value,
            deliveryCountry = document.getElementById('frm-orderForm-deliveryCountry').value,
            country = deliveryCountry !== '' ? deliveryCountry : billingCountry;

        FNP.order.setShippingPayment(country);
    });


}

naja.addEventListener('success', _ => [...document.getElementsByClassName('set-delivery-address')].forEach(element =>
    element.addEventListener('click', e => {
        const
            link = e.target.dataset.link,
            addressId = e.target.dataset.addressId

        naja.makeRequest('POST', link, {
            addressId: addressId
        }, {
            history: false
        }).then(r => {
            Object.entries({
                addressee: "addressee",
                deliveryCountry: "country",
                deliveryStreet: "street",
                deliveryCity: "city",
                deliveryZip: "zip"
            }).forEach(([k,v]) => {
                let obj = document.getElementById("frm-orderForm-"+k);
                obj.value = r.deliveryAddress[v];
                obj.setAttribute("readonly","");
            });
            document.getElementById('delivery-customer-code').value = r.deliveryAddress.customerCode;
            switchForm.modal[2].checked = true;
        })
    })
));
